import { render } from "./ThePersonalDetails.vue?vue&type=template&id=4d45a382&scoped=true"
import script from "./ThePersonalDetails.vue?vue&type=script&lang=js"
export * from "./ThePersonalDetails.vue?vue&type=script&lang=js"

import "./ThePersonalDetails.vue?vue&type=style&index=0&id=4d45a382&scoped=true&lang=css"

import exportComponent from "/home/cyrill/Projects/kmapper/repos/cyrill.codeberg.page/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d45a382"]])

export default __exports__